var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"margin-top-30"},[_c('ReturnDispatchLines')],1),_c('div',[_c('SaveTheReturnDispatch')],1),_c('div',{staticClass:"margin-top-30"},[_c('DispatchToSelectItemFrom')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }